<template>
  <el-dialog
    title="分享"
    :model-value="modelValue"
    width="416px"
    top="50px"
    :before-close="handleClose"
    class="poster">
      <div>
        <div class="dialog-poster" id="poster">
          <img class="exhibition-logo" :src="logo(info.pic)" :alt="info.exhibitionName"/>
          <img class="ear_wheat" src="~/assets/images/ear-wheat.png"/>
          <div class="exhibition-info">
            <p class="exhibition-title ellipsis">{{ info.exhibitionName }}</p>
            <p class="exhibition-content ellipsis">
              <span class="label_width">{{$t('exhibition.time')}}:</span>
              <span class="content_value">{{ getStart(info.startTime) }} - {{ getEnd(info.endTime) }}</span>
            </p>
            <p class="exhibition-content ellipsis">
              <span class="label_width">{{$t('exhibitionDetail.exhibitionHall')}}:</span>
              <span class="content_value">{{ info.pavilionInfo.pavilionName }}</span>
            </p>
            <p class="exhibition-content ellipsis">
              <span class="label_width">{{$t('exhibitionDetail.exhibitionAddress')}}:</span>
              <span class="content_value">
                 {{
                  info.pavilionInfo.pavilionAddress
                  }}
              </span>
            </p>
            <div class="qrcode_box">
              <img :src="qrcodeUrl" alt="">
            </div>
          </div>
        </div>
      </div>
    <div class="share-text" @click="handleConfirm">分享</div>
    <img @click="handleClose" class="close_icon" src="~/assets/images/close-icon.png" />
  </el-dialog>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue'
  import html2canvas from 'html2canvas'
  import { fetchGetLatestPoster } from '~/api/poster'
  import { fetchCreateWXACode } from '~/api/wx'

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({})
    }
  })
  const emit = defineEmits(['update:modelValue'])

  const bgImage = ref(
    'https://dcdn-jufair-test.jufair.com/jufair/mfKtYsM2QxMPQDSpYBaeKRcKBfW2p7Jh.png'
  )
  const bgHeight = ref('')
  const qrcodeUrl = ref('')
  const imgUrl1 = ref('https://dcdn-jufair.jufair.com/jufair/JSSacTBfA5p8acFmre5XpM4WhHfn5seY.png')
  const downLoading = ref(false)

  const globalStore = useGlobalStore()
  const isLogin = computed(() => globalStore.isLogin)

  const getYear = (str: string) => str.slice(0, 4)
  const getStart = (str: string) => str.replace(new RegExp('-', 'g'), '.')
  const getEnd = (str: string) => {
    const s = str.replace(new RegExp('-', 'g'), '.')
    return s.slice(5, 10)
  }
  const logo = (value: string) => {
    let parse: any = value;
      if (typeof value === 'string') {
        try {
          parse = JSON.parse(value)[0]
            .replace('http://', 'https://')
            .replace(bucketHost, bucketCdnHost);
        } catch (error) {
          parse = value;
          console.error(error);
        }
      }
      return parse + '!logo';
  }

  // 关闭对话框
  const handleClose = () => {
    emit('update:modelValue', false)
  }

  // 获取海报图片
  const getPoster = async () => {
    await getQrcode()
    await getImageUrl()
    const res = await fetchGetLatestPoster(props.info.posterTag)
    if (res) {
      bgImage.value =
        res.data?.bgImage ||
        'https://dcdn-jufair-test.jufair.com/jufair/mfKtYsM2QxMPQDSpYBaeKRcKBfW2p7Jh.png'
    }
  }

  // 获取二维码
  const getQrcode = async () => {
    const res = await fetchCreateWXACode(
      {
        page: 'views/exh-info/exh-info',
        scene: `id=${props.info.exhibitionId}`,
        checkPath: true,
        autoColor: false,
        lineColor: { r: 0, g: 0, b: 0 },
        envVersion: 'release'
      },
      { responseType: 'arrayBuffer' }
    )

    const blob = new Blob([res as any], { type: 'image/png' })
    const blobUrl = URL.createObjectURL(blob)
    qrcodeUrl.value = blobUrl
  }

  // 获取图片 URL
  const getImageUrl = async () => {
    // 示例代码，实际实现可能需要���据具体需求调整
  }

  // 将图片转换为 Base64
  const convertImageToBase64 = (image: HTMLImageElement) => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    canvas.width = image.width
    canvas.height = image.height
    context?.drawImage(image, 0, 0)
    return canvas.toDataURL('image/png')
  }

  // 获取 Base64 图片
  const getBase64Image = (src: string) => {
    return new Promise(resolve => {
      const img = new Image()
      img.crossOrigin = ''
      img.src = src
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        ctx?.drawImage(img, 0, 0, img.width, img.height)
        const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
        const dataURL = canvas.toDataURL('image/' + ext)
        resolve(dataURL)
      }
    })
  }

  // 确认下载
  const handleConfirm = () => {
    downLoading.value = true
    const element = document.getElementById('poster')
    html2canvas(element as any, { scale: 2, useCORS: true }).then((canvas: any) => {
      const url = canvas.toDataURL('image/png')
      let link: HTMLAnchorElement | undefined = document.createElement('a')
      link.download = `${props.info.exhibitionName}.png` || 'image.png'
      link.href = url
      link.click()
      setTimeout(() => {
        downLoading.value = false
        ElMessage.success('下载成功~')
        link = undefined
      }, 3000)
    })
  }

  watch(
    () => props.modelValue,
    newValue => {
      // console.log('newValue', newValue);
      if (newValue) {
        getPoster()
      }
    },
    { immediate: true }
  )
</script>

<style lang="less" scoped>
  .poster {
    :deep {
      .el-dialog__body {
        padding: 30px 20px;
      }
    }
  }
.dialog-poster{
  position: absolute;
  top: 0;
  left: 0;
  width: 500px;
  height: 710px;
  background: url('~/assets/images/share-bg.png');
  .exhibition-logo{
    width: 256px;
    height: 112px;
    position: absolute;
    top:88px;
    left: 50%;
    transform: translateX(-50%);
    object-fit:contain;
  }
  .ear_wheat{
    width: 330px;
    height: 108px;
    position: absolute;
    top:140px;
    left: 50%;
    transform: translateX(-50%);
  }
  .exhibition-info{
    margin-top:300px;
    .exhibition-title{
      width: 85%;
      font-weight: bold;
      font-size: 20px;
      color: #333;
      text-align: center;
      margin: 0 0 20px 35px;
    }
   .exhibition-content{
      width: 85%;
      text-align: center;
      margin: 0 0 10px 35px;
      font-size: 14px;
      .label_width{
        color: #999;
      }
      .content_value{
        color: #333;
      }
   }
   .qrcode_box{
    width: 148px;
    height: 148px;
    margin: 0 auto;
    margin-top: 40px;
    img{
      width:100%;
      height:100%;
    }
   }
  } 
  
}
.share-text{
  width: 110px;
  height: 36px;
  background: #E00022;
  border-radius: 4px 4px 4px 4px;
  line-height:36px;
  text-align: center;
  font-size: 14px;
  color: #FFF;
  position: absolute;
  left: 50%;
  transform: translateX(-15%);
  top:630px;
  cursor: pointer;
}
.close_icon{
  width: 40px;
  height: 40px;
  position: absolute;
  top:0;
  left: 505px;
  cursor: pointer;
}
</style>
